/**
 * Next serves each child at /sitemap/<id>.xml via generateSitemaps; the index
 * is served at /sitemap.xml.
 */
export const SITEMAP_SOURCES = [
  "sitemap-catalog",
  "sitemap-blog",
  "sitemap-cms",
] as const

export type SitemapSource = (typeof SITEMAP_SOURCES)[number]

/** Public path of the sitemap index. */
export const SITEMAP_INDEX_PATH = "/sitemap.xml"

/** Path Next serves a generateSitemaps child at, for a given source id. */
export const childSitemapPath = (id: SitemapSource) => `/sitemap/${id}.xml`
